import { GridType } from "../../../../Entities/GridType";
import ProjectCapacity from "./ProjectCapacity";

export const RequestView = () => <ProjectCapacity gridType={GridType.Request} />